<template>
    <el-dropdown-menu slot="dropdown">
        <div  class="user-file-list">
            <div class="header-wrap">
                <h4 class="title" @click="toAll">{{ $translate('component.E1202104124674', { defaultText: '文件信息' }) }}</h4>
                <el-button class="refresh" icon="el-icon-refresh" @click="refresh"></el-button>
            </div>
            <div class="content-wrap">
                <el-table border :data='displayData'
                    v-loadmore="loadMoreList"
                    ref="dataTable"
                    :height="235"
                    v-loading="loading">
                    <el-table-column
                        v-for="(item, index) in columns"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <div
                                class="status"
                                v-if="item.prop === 'fileStatus'">
                                <el-tooltip v-if="scope.row.remark && scope.row.remark.length" class="item" effect="dark" :content="scope.row.remark" placement="top">
                                    <span>
                                        <div :class="['point', scope.row.fileStatusPoint]"></div>
                                        {{scope.row.fileStatusText}}
                                    </span>
                                </el-tooltip>
                                <span v-else>
                                    <div :class="['point', scope.row.fileStatusPoint]"></div>
                                    {{scope.row.fileStatusText}}
                                </span>
                            </div>
                            <span v-else>{{scope.row[item.prop]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" width="60" :label="$translate('component.E202006152352', { defaultText: '操作' })">
                        <template slot-scope="scope">
                            <a
                                v-if="displayDownBtn(scope.row, scope.$index)"
                                :href="scope.row.ossUrl + '?pro=https'"
                                target="_blank"
                                class="el-button--text"
                                @click="bigDataRecord"
                                >
                                {{ $translate('component.E1202104124673', { defaultText: '下载' }) }}
                            </a>
                        </template>
                    </el-table-column>
                    <!-- 加载更多提示 -->
                    <template slot="append">
                        <div
                            class="loadMoreText"
                            v-html="loadMoreText">
                        </div>
                    </template>
                </el-table>
            </div>
        </div>
    </el-dropdown-menu>
</template>

<script>
import bigDataLog from '@/utils/bigDataLog';
import { getUserFileList, geLoopTimeSetting } from './api';
import { I18nMixins } from '@/components/utils/i18n';

export default {
    mixins: [I18nMixins],
    data() {
        return {
            loading: false, // 表格加载中显示
            tableData: [], // 实际数据列表
            columns: [ // 表格配置项
                {
                    label: this.$translate('component.E1202104124675', { defaultText: '文件名' }),
                    prop: 'localFileName',
                    width: '160'
                },
                {
                    label: this.$translate('component.E1202104124676', { defaultText: '状态' }),
                    prop: 'fileStatus',
                    width: '100'
                },
                {
                    label: this.$translate('component.E1202104124677', { defaultText: '更新时间' }),
                    prop: 'updateTime',
                    width: '150'
                }
            ],
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            total: 0, // 总记录数
            totalPage: 0, // 总页数
            loadMoreStatus: false, // 加载更多的状态
            loadMoreFinished: false, // 加载完成状态，true为已全部加载完
            loadMoreText: '', // 下拉加载显示的文字
            exportedIdList: [], // 已点击导出的文件的ID列表
            loopTimer: { // 轮询时间配置
                timeout: null, // 定时器ID
                interval: 30000, // 轮询间隔，默认30秒
                end: 600000 // 轮询结束时间，默认等待10分钟
            }
        };
    },
    computed: {
        displayData() { // 显示在表格中的数据
            const newData = [];
            this.tableData.forEach((item) => { // 从实际数据提取处理
                const newItem = JSON.parse(JSON.stringify(item));
                if (newItem['fileStatus'] === null) {
                    newItem['fileStatusPoint'] = `blue`; newItem['fileStatusText'] = this.$translate('component.E1202104123424', { defaultText: '已生成' });
                } else {
                    switch (newItem['fileStatus']) {
                    case 1: newItem['fileStatusPoint'] = `green`; newItem['fileStatusText'] = this.$translate('component.E1202104123422', { defaultText: '已提交' }); break;
                    case 2: newItem['fileStatusPoint'] = `orange`; newItem['fileStatusText'] = this.$translate('component.E1202104123423', { defaultText: '生成中' }); break;
                    case 3: newItem['fileStatusPoint'] = `blue`; newItem['fileStatusText'] = this.$translate('component.E1202104123424', { defaultText: '已生成' }); break;
                    case 4: newItem['fileStatusPoint'] = `red`; newItem['fileStatusText'] = this.$translate('component.E1202104123425', { defaultText: '失败' }); break;
                    default: newItem['fileStatusPoint'] = ``; newItem['fileStatusText'] = ``; break;
                    };
                }
                newData.push(newItem);
            });
            return newData;
        }
    },
    directives: { // 自定义指令
        loadmore: { // 监听element-ui表格滚动到底部
            bind(el, binding) {
                const selectWrap = el.querySelector('.el-table__body-wrapper');
                selectWrap.addEventListener('scroll', function() {
                    const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
                    binding.value(scrollDistance);
                });
            }
        }
    },
    methods: {
        bigDataRecord() {
            bigDataLog.sendDetailMessageByKey('bigData-btn-header-bar-file');
        },
        loadMoreList(scrollDistance) { // 表格下拉加载
            if (scrollDistance === 0 && !this.loadMoreFinished && !this.loadMoreStatus) {
                this.loadMoreText = `<i class="el-icon-loading"></i>${this.$translate('component.E202006240015', { defaultText: '加载中...' })}`;
                this.handleGetUserFileList('add');
            }
        },
        async handleGetUserFileList(val) { // 获取用户文件列表
            this.loadMoreStatus = true;
            if (val && val === 'add') {
                this.currentPage++;
            } else {
                this.loading = true;
                this.loadMoreFinished = false;
                this.currentPage = 1;
                this.tableData = [];
            }
            const res = await this.handleApiFunc(this.currentPage, this.pageSize);
            if (res && res.code === '0') {
                this.loading = false;
                const list = res.data.list;
                if (this.pageSize >= list.length) {
                    this.tableData = this.tableData.concat(list);
                }/* else{
                    console.log('服务器返回数据超过每页显示数量：' + this.pageSize + '条');
                } */
                this.setLoadMore(list);
            }
        },
        handleApiFunc(pageNo, pageSize = 10) { // 处理api函数
            const params = {
                asc: 'desc',
                orderBy: 'updateTime',
                pageSize: pageSize,
                pageNo: pageNo
            };
            return getUserFileList(params);
        },
        setLoadMore(list) { // 设置loadmore相关值
            this.loadMoreStatus = false;
            if (this.pageSize > list.length) {
                this.loadMoreFinished = true;
                this.loadMoreText = this.$translate('component.E1202104123837', { defaultText: '已经加载到底了！' });
            } else {
                this.loadMoreFinished = false;
                this.loadMoreText = '';
            }
        },
        displayDownBtn(row, index) { // 显示下载按钮
            return row['fileStatusText'] === this.$translate('component.E1202104123424', { defaultText: '已生成' });
        },
        refresh() { // 刷新按钮操作
            this.$refs.dataTable.bodyWrapper.scrollTop = 0; // 滚到表格顶部
            if (this.loopTimer.timeout === null) this.handleGetUserFileList();
            else this.handleLoopFile(true);
        },
        toAll() { // 跳转全部文件列表（详情）
            const origin = window.location.origin;
            this.downLoadFile(`${origin}/mdm.html#/oss-file`, '_new');
        },
        handleLoop() { // 开启轮询
            this.loopTimer.timeout = setTimeout(() => {
                this.handleLoopFile(false);
            }, this.loopTimer.interval);
        },
        async handleLoopFile(refresh) { // 查看新增导出文件列表中是否有成功或失败的状态的文件，已变更状态的弹出提醒通知 并刷新文件列表
            const res = await this.handleApiFunc(1, 999);
            if (res && res.code === '0') {
                const list = res.data.list;
                let fileStatusFlag = false; // 标识文件状态是否发生变化
                this.exportedIdList.forEach((item, index) => {
                    list.some((fileItem) => {
                        if (item.id === fileItem.id) {
                            if (fileItem.fileStatus === 3 || fileItem.fileStatus === null || fileItem.fileStatus === 4) fileStatusFlag = true;
                            if (fileItem.fileStatus === 3 || fileItem.fileStatus === null) {
                                this.exportedIdList[index].url = fileItem.ossUrl;
                                this.exportedIdList[index].fileName = fileItem.localFileName;
                                this.exportedIdList[index].title = this.$translate('component.E1202104123838', { defaultText: '文件导出成功' });
                                this.exportedIdList[index].message = `${this.$translate('component.E1202104123839', { defaultText: '你的导出文件：' })}
                                                                        ${fileItem.localFileName} ${this.$translate('component.E1202104123840', { defaultText: '导出成功！' })}`;
                                this.exportedIdList[index].id = -1;
                                return true;
                            } else if (new Date(item.time).getTime() + this.loopTimer.end < new Date().getTime() || fileItem.fileStatus === 4) {
                                this.exportedIdList[index].title = this.$translate('component.E1202104123841', { defaultText: '文件导出失败' });
                                this.exportedIdList[index].message = fileItem.remark.length ? fileItem.remark : `${this.$translate('component.E1202104123839', { defaultText: '你的导出文件：' })}
                                                                        ${fileItem.localFileName} ${this.$translate('component.E1202104123842', { defaultText: '导出失败，请重新导出！' })}`;
                                this.exportedIdList[index].id = -1;
                                return true;
                            }
                        }
                    });
                });
                this.exportedIdList = this.exportedIdList.filter(item => {
                    if (item.message) { // 顺便输出通知消息
                        setTimeout(() => { // 延迟避免样式重叠的bug
                            const h = this.$createElement;
                            this.$notify({
                                title: item.title,
                                message: h('span', { style: 'word-break: break-all;' }, item.message),
                                offset: 40,
                                duration: item.url ? 5000 : 0
                            });
                        }, 1);
                    }
                    if (item.url) this.downLoadFile(item.url);
                    return item.id !== -1 && new Date(item.time).getTime() + this.loopTimer.end >= new Date().getTime(); // 保留id不为-1（即未改变为成功或失败状态） 且 生成时间在10分钟内的文件
                });
                if (refresh || fileStatusFlag) { // 当为点击刷新按钮 或 获取到新状态变化的文件
                    this.$refs.dataTable.bodyWrapper.scrollTop = 0; // 滚到表格顶部
                    this.currentPage = 1;
                    this.tableData = list.slice(0, 10);
                    this.setLoadMore(this.tableData);
                }
                if (!refresh && this.exportedIdList.length > 0) { // 当不为刷新按钮操作 及 仍有文件状态未改变时候，继续轮询
                    this.handleLoop();
                } else if (this.exportedIdList.length <= 0) { // 当没有文件状态未改变时候，结束轮询
                    clearTimeout(this.loopTimer.timeout);
                    this.loopTimer.timeout = null;
                }
            }
        },
        downLoadFile(url, target, fileName) { // 下载文件操作
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            if (fileName) a.download = fileName;
            if (target) a.target = target;
            a.click();
        },
        getTimeSetting() { // 数据字典获取轮询时间的配置
            const params = {
                dictCodes: 'MDM_FILE_SEARCH'
            };
            geLoopTimeSetting(params).then((res) => {
                if (res && res.code === '0') {
                    if (res.data.MDM_FILE_SEARCH && res.data.MDM_FILE_SEARCH.FREQUENCY && res.data.MDM_FILE_SEARCH.MAX_TIME) {
                        this.loopTimer.interval = parseInt(res.data.MDM_FILE_SEARCH.FREQUENCY) * 1000;
                        this.loopTimer.end = parseInt(res.data.MDM_FILE_SEARCH.MAX_TIME) * 1000;
                    }
                }
            });
        }
    },
    mounted() {
        this.handleGetUserFileList();
        this.getTimeSetting();
        this.$root.$on('loopGetNewFile', (val) => {
            this.exportedIdList.push(val);
            if (this.loopTimer.timeout === null) this.handleLoop();
        });
    }
};
</script>
<style lang="less">
.user-file-list {
    padding: 5px 15px;
    .header-wrap {
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        .title {
            cursor: pointer;
            padding: 0;
            margin: 0;
        }
        .refresh {
            padding: 6px;
            i { font-size: 16px; }
        }
    }
    .content-wrap {
        width: 478px;
        margin-top: 10px;
        border: 1px solid #eee;
        .el-table td { height: 42px; }
        .status {
            line-height: 16px;
            .point {
                background: #eee;
                border-radius: 50%;
                width: 10px;
                height: 10px;
                display: inline-block;
                margin-right: 5px;
                &.green { background: #00d082; }
                &.orange { background: #ff8800; }
                &.blue { background: #00bcbf; }
                &.red { background: #ed0000; }
            }
        }
        .loadMoreText {
            text-align: center;
            margin: 1rem 0;
        }
    }
}
</style>
